{
  "map": "arena2",
  "hiddenBoxIndices": [
    0,
    1,
    2,
    3,
    4
  ],
  "placements": [
    {
      "asset": "buildings/SM_Bld_LandingPad_01.glb",
      "position": {
        "x": 15,
        "y": 0.8989220038046923,
        "z": 15
      },
      "rotationY": 0,
      "scale": {
        "x": 0.25364616360177555,
        "y": 0.25364616360177555,
        "z": 0.25364616360177555
      },
      "note": "platform box#0 — top-anchored to y=1.2"
    },
    {
      "asset": "buildings/SM_Bld_LandingPad_01.glb",
      "position": {
        "x": 15,
        "y": 0.8989220038046923,
        "z": 23
      },
      "rotationY": 0,
      "scale": {
        "x": 0.25364616360177555,
        "y": 0.25364616360177555,
        "z": 0.25364616360177555
      },
      "note": "platform box#1 — top-anchored to y=1.2"
    },
    {
      "asset": "buildings/SM_Bld_LandingPad_01.glb",
      "position": {
        "x": 45,
        "y": 0.8989220038046923,
        "z": 15
      },
      "rotationY": 0,
      "scale": {
        "x": 0.25364616360177555,
        "y": 0.25364616360177555,
        "z": 0.25364616360177555
      },
      "note": "platform box#2 — top-anchored to y=1.2"
    },
    {
      "asset": "buildings/SM_Bld_LandingPad_01.glb",
      "position": {
        "x": 45,
        "y": 0.8989220038046923,
        "z": 23
      },
      "rotationY": 0,
      "scale": {
        "x": 0.25364616360177555,
        "y": 0.25364616360177555,
        "z": 0.25364616360177555
      },
      "note": "platform box#3 — top-anchored to y=1.2"
    },
    {
      "asset": "buildings/SM_Bld_LandingPad_01.glb",
      "position": {
        "x": 30,
        "y": 0.5978440076093847,
        "z": 20
      },
      "rotationY": 0,
      "scale": {
        "x": 0.5072923272035511,
        "y": 0.5072923272035511,
        "z": 0.5072923272035511
      },
      "note": "platform box#4 — top-anchored to y=1.2"
    }
  ],
  "skyline": [
    {
      "asset": "buildings/SM_Bld_Background_Lrg_01.glb",
      "position": {
        "x": -16.215762665960938,
        "y": 0,
        "z": 2.2834569606930017
      },
      "rotationY": 3.594203058264169,
      "scale": {
        "x": 1.1048587277298794,
        "y": 1.1048587277298794,
        "z": 1.1048587277298794
      }
    },
    {
      "asset": "buildings/SM_Bld_Background_Med_01.glb",
      "position": {
        "x": -14.92326934542507,
        "y": 0,
        "z": 17.87471084203571
      },
      "rotationY": 0.6587836920479266,
      "scale": {
        "x": 0.9976474267197772,
        "y": 0.9976474267197772,
        "z": 0.9976474267197772
      }
    },
    {
      "asset": "buildings/SM_Bld_Background_Lrg_01.glb",
      "position": {
        "x": -15.056999838910997,
        "y": 0,
        "z": 35.14924460556358
      },
      "rotationY": 6.214575199738931,
      "scale": {
        "x": 1.056603550980799,
        "y": 1.056603550980799,
        "z": 1.056603550980799
      }
    },
    {
      "asset": "buildings/SM_Bld_Background_Med_01.glb",
      "position": {
        "x": -5.4266923842951655,
        "y": 0,
        "z": 3.2685973988845944
      },
      "rotationY": 6.234585034188854,
      "scale": {
        "x": 0.9843685069121421,
        "y": 0.9843685069121421,
        "z": 0.9843685069121421
      }
    },
    {
      "asset": "buildings/SM_Bld_Background_Lrg_01.glb",
      "position": {
        "x": -6.558710944373161,
        "y": 0,
        "z": 21.669848800171167
      },
      "rotationY": 2.0503813872319587,
      "scale": {
        "x": 1.0501775558339432,
        "y": 1.0501775558339432,
        "z": 1.0501775558339432
      }
    },
    {
      "asset": "buildings/SM_Bld_Background_Med_01.glb",
      "position": {
        "x": -4.239709376823157,
        "y": 0,
        "z": 33.3796377312392
      },
      "rotationY": 0.00033716311848294006,
      "scale": {
        "x": 1.0655096920439973,
        "y": 1.0655096920439973,
        "z": 1.0655096920439973
      }
    },
    {
      "asset": "buildings/SM_Bld_Background_Lrg_01.glb",
      "position": {
        "x": 67.27563991909847,
        "y": 0,
        "z": 3.528162661008537
      },
      "rotationY": 5.1937556161058,
      "scale": {
        "x": 1.1297667701961474,
        "y": 1.1297667701961474,
        "z": 1.1297667701961474
      }
    },
    {
      "asset": "buildings/SM_Bld_Background_Med_01.glb",
      "position": {
        "x": 64.84697706997395,
        "y": 0,
        "z": 19.559951504226774
      },
      "rotationY": 0.5113795777663291,
      "scale": {
        "x": 0.9690317407483235,
        "y": 0.9690317407483235,
        "z": 0.9690317407483235
      }
    },
    {
      "asset": "buildings/SM_Bld_Background_Lrg_01.glb",
      "position": {
        "x": 65.3488161652349,
        "y": 0,
        "z": 34.58594398712739
      },
      "rotationY": 5.086923047791942,
      "scale": {
        "x": 0.8873112748144194,
        "y": 0.8873112748144194,
        "z": 0.8873112748144194
      }
    },
    {
      "asset": "buildings/SM_Bld_Background_Med_01.glb",
      "position": {
        "x": 73.58591093122959,
        "y": 0,
        "z": 3.435180532746017
      },
      "rotationY": 6.029425407141181,
      "scale": {
        "x": 0.9053912032628432,
        "y": 0.9053912032628432,
        "z": 0.9053912032628432
      }
    },
    {
      "asset": "buildings/SM_Bld_Background_Lrg_01.glb",
      "position": {
        "x": 74.88721276586875,
        "y": 0,
        "z": 22.97060818877071
      },
      "rotationY": 4.005711271232994,
      "scale": {
        "x": 1.086761056398973,
        "y": 1.086761056398973,
        "z": 1.086761056398973
      }
    },
    {
      "asset": "buildings/SM_Bld_Background_Med_01.glb",
      "position": {
        "x": 75.97318215295672,
        "y": 0,
        "z": 36.640093812253326
      },
      "rotationY": 5.059474128617138,
      "scale": {
        "x": 0.9096081722062082,
        "y": 0.9096081722062082,
        "z": 0.9096081722062082
      }
    },
    {
      "asset": "buildings/SM_Bld_Background_Lrg_01.glb",
      "position": {
        "x": 7.231457427144051,
        "y": 0,
        "z": -15.510817175265402
      },
      "rotationY": 5.185461430893978,
      "scale": {
        "x": 1.1388527954928578,
        "y": 1.1388527954928578,
        "z": 1.1388527954928578
      }
    },
    {
      "asset": "buildings/SM_Bld_Background_Med_01.glb",
      "position": {
        "x": 7.634138406720012,
        "y": 0,
        "z": -7.132170069031417
      },
      "rotationY": 6.209193210437474,
      "scale": {
        "x": 0.8983896936522797,
        "y": 0.8983896936522797,
        "z": 0.8983896936522797
      }
    },
    {
      "asset": "buildings/SM_Bld_Background_Lrg_01.glb",
      "position": {
        "x": 9.563876952044666,
        "y": 0,
        "z": 46.106118651106954
      },
      "rotationY": 5.859633629900703,
      "scale": {
        "x": 0.9475423408905044,
        "y": 0.9475423408905044,
        "z": 0.9475423408905044
      }
    },
    {
      "asset": "buildings/SM_Bld_Background_Med_01.glb",
      "position": {
        "x": 7.167381060309708,
        "y": 0,
        "z": 57.807054456323385
      },
      "rotationY": 4.768157333989038,
      "scale": {
        "x": 0.9658641638699919,
        "y": 0.9658641638699919,
        "z": 0.9658641638699919
      }
    },
    {
      "asset": "buildings/SM_Bld_Background_Lrg_01.glb",
      "position": {
        "x": 31.014527983032167,
        "y": 0,
        "z": -14.249907817225903
      },
      "rotationY": 3.723466163277057,
      "scale": {
        "x": 0.8686134196119383,
        "y": 0.8686134196119383,
        "z": 0.8686134196119383
      }
    },
    {
      "asset": "buildings/SM_Bld_Background_Med_01.glb",
      "position": {
        "x": 31.03370187850669,
        "y": 0,
        "z": -6.426821964792907
      },
      "rotationY": 5.582834246198182,
      "scale": {
        "x": 0.9569502342725172,
        "y": 0.9569502342725172,
        "z": 0.9569502342725172
      }
    },
    {
      "asset": "buildings/SM_Bld_Background_Lrg_01.glb",
      "position": {
        "x": 32.65921432804316,
        "y": 0,
        "z": 45.3721352792345
      },
      "rotationY": 3.2786338702036786,
      "scale": {
        "x": 1.0439964279998093,
        "y": 1.0439964279998093,
        "z": 1.0439964279998093
      }
    },
    {
      "asset": "buildings/SM_Bld_Background_Med_01.glb",
      "position": {
        "x": 32.80494675831869,
        "y": 0,
        "z": 53.678761744406074
      },
      "rotationY": 5.154150845402415,
      "scale": {
        "x": 0.9183173145866022,
        "y": 0.9183173145866022,
        "z": 0.9183173145866022
      }
    },
    {
      "asset": "buildings/SM_Bld_Background_Lrg_01.glb",
      "position": {
        "x": 48.189146019052714,
        "y": 0,
        "z": -16.28941379673779
      },
      "rotationY": 1.6931914059326536,
      "scale": {
        "x": 0.8916821216000244,
        "y": 0.8916821216000244,
        "z": 0.8916821216000244
      }
    },
    {
      "asset": "buildings/SM_Bld_Background_Med_01.glb",
      "position": {
        "x": 51.299258332233876,
        "y": 0,
        "z": -7.771489161066711
      },
      "rotationY": 4.766911589024474,
      "scale": {
        "x": 0.875241462350823,
        "y": 0.875241462350823,
        "z": 0.875241462350823
      }
    },
    {
      "asset": "buildings/SM_Bld_Background_Lrg_01.glb",
      "position": {
        "x": 49.25051573012024,
        "y": 0,
        "z": 45.98850719165057
      },
      "rotationY": 2.7992409669821643,
      "scale": {
        "x": 1.0572106440551579,
        "y": 1.0572106440551579,
        "z": 1.0572106440551579
      }
    },
    {
      "asset": "buildings/SM_Bld_Background_Med_01.glb",
      "position": {
        "x": 48.88681057514623,
        "y": 0,
        "z": 54.230890575330704
      },
      "rotationY": 1.4037045550490557,
      "scale": {
        "x": 1.0167129644425585,
        "y": 1.0167129644425585,
        "z": 1.0167129644425585
      }
    }
  ],
  "wallDecor": [],
  "capProps": [
    {
      "asset": "props/SM_Prop_ControlPanel_01.glb",
      "position": {
        "x": 15,
        "y": 0,
        "z": 22.8
      },
      "rotationY": 0,
      "scale": {
        "x": 1.3,
        "y": 1.3,
        "z": 1.3
      },
      "note": "cap A marker"
    },
    {
      "asset": "props/SM_Prop_ControlPanel_01.glb",
      "position": {
        "x": 32.8,
        "y": 1.2,
        "z": 20
      },
      "rotationY": -1.5707963267948966,
      "scale": {
        "x": 1.3,
        "y": 1.3,
        "z": 1.3
      },
      "note": "cap B marker (on the platform itself)"
    },
    {
      "asset": "props/SM_Prop_ControlPanel_01.glb",
      "position": {
        "x": 45,
        "y": 0,
        "z": 22.8
      },
      "rotationY": 0,
      "scale": {
        "x": 1.3,
        "y": 1.3,
        "z": 1.3
      },
      "note": "cap C marker"
    }
  ]
}